<template>
  <div id="compreSportsMeet_record" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
      ></marathon_select_opt>
    </div>
    <div class="teamTable">
      <div class="tableScrollArea" ref="tableParentDom">
        <multiLevelFold_table
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :tableMode="tableMode"
          :parentWidthPx="parentWidthPx"
          :isScrollFlag="isScrollFlag"
          :variableColWidthVw="variableColWidthVw"
          :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
          :defaultWidthVwNum="defaultWidthVwNum"
          :tableColumnData="tableColumnData"
          :tableData="tableData"
          :tableHeightPx="tableHeightPx"
          v-show="tableData && tableData.length > 0"
        ></multiLevelFold_table>
        <p class="loadingClass" v-show="loading">加载中...</p>
        <p class="noMoreClass" v-show="noMore">没有更多了</p>
        <p class="noDataClass" v-show="noData">暂无数据</p>
      </div>
    </div>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
  </div>
</template>

<script>
import {
  https_select_recordTypeList,
  https_select_recordTypeGetSportsList,
  https_recordList,
  https_record_newSportsList,
  https_record_newRecordType,
} from '@api/platfrom_compreSportsMeet_api'
import BackTop from '@components/base/backTop.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'
export default {
  name: 'compreSportsMeet_record',
  components: {
    BackTop,
    marathon_select_opt,
    multiLevelFold_table,
  },
  mixins: [cup_base_data_mixin, single_findAnalysisItem_data_mixin],
  data() {
    return {
      // themeList: null,
      detailPathName: 'CSMeetPlayerDetailIndex',
      loading: false,
      isScrollBottom: false,
      tableMode: 'records_table',
      scrollDomClassName: 'el-table__body-wrapper',
      scrollDomById: 'containerFull_body',
      showBackTop: false,
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: 27.88,
      tableCellDefaultWidthVw: 6.94,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      curMatchLabelFixedIcon: null,
      bigSportsArr: [],
      recordTypeArr: [],
      curInputVal: '',
      currStageBigSports: '',
      currStageRecordType: '',
      selectOptData: {
        configArr: [
          {
            type: 'recordType',
            title: '纪录类型',
            origin_keyVal: ['value', 'name'],
            dataName: 'recordTypeArr',
            selectIndex: 0,
          },
          // {
          //   type: 'bigSports',
          //   title: '项目',
          //   origin_keyVal: ['value', 'name'],
          //   dataName: 'bigSportsArr',
          //   selectIndex: 0,
          //   isFilterable: true
          // },
        ],
        selectOpt_list: [],
      },
      themeTemplateType: 13,
    }
  },
  created() {
    this.query = this.$route.query
    if (this.currGroup) {
      console.debug('init ')
      this.init()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
    window.removeEventListener('scroll', () => {
      this.scrollListenerEvent()
    })
  },
  computed: {
    noMore() {
      // return this.tableTotal !== 0 && this.isScrollBottom
      return this.tableTotal !== 0
    },
    noData() {
      return this.tableData && this.tableData.length == 0
    },
    tableHeightPx() {
      // let clientHeight = window.innerHeight
      //   ? window.innerHeight
      //   : window.screen.height
      //   ? window.screen.height
      //   : 667
      // let clientWidth = window.innerWidth
      //   ? window.innerWidth
      //   : window.screen.width
      //   ? window.screen.width
      //   : 375

      // return Math.floor(clientHeight - (clientWidth / 100) * (42 - 26))
      return 'auto'
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      console.debug(this.currCid, this.currSid)
      // await this.findAnalysisItem(this.themeTemplateType)
      await this.getBigSportsList()
      await this.getRecordTypeList()
      await this.getRecordList()
      this.makeAnalysisItemParams(this.themeTemplateType)
      console.debug(this.stageArr)
      this.computedSelectOpt(this.selectOptData.configArr)

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      this.findAnalysisItemParams = {
        sportType: 'compreSportsMeet',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: 0,
        eid: 0,
        pid: 0,
        mid: 0,
      }
      if (this.initSingleFindAnalysisItem) {
        this.initSingleFindAnalysisItem(this.findAnalysisItemParams)
      }
    },
    findAnalysisItemCallback(resData) {
      console.debug('resData:', resData)
      // 无论接口报错还是接口正常都会进入这个函数；因此先组装基本数据，有主题则在添加主题字段
      let isShareFlag = false
      if (resData && resData.length > 0) {
        isShareFlag = true
      }
      this.computedTableData(this.orgin_tableData, isShareFlag)
      let jsonArr = []
      if (isShareFlag) {
        this.themeList = resData.map((item) => {
          jsonArr.push(item.json)
          item.actJson = JSON.parse(item.json)
          item.renderData = null
          return item
        })
        this.themeItem = this.themeList[0]
        this.shareDataAddThemeItem(this.themeItem)
      } else {
        this.themeList = []
        this.themeItem = null
      }
    },
    shareDataAddThemeItem(themeItem) {
      // 主题不同，有些地方需要特殊处理
      // json里面设置不同的参数
      let isShareFlag = true
      if (!themeItem) {
        console.error('分享接口异常')
        isShareFlag = false
        return
      }

      let jsonObj = null
      if (isShareFlag) {
        jsonObj = JSON.parse(themeItem.json)
        const keyArr = Object.keys(jsonObj)
        jsonObj[keyArr[0]] = this.currStageRecordType
      }

      this.tableData = this.tableData
        ? this.tableData.map((record, index) => {
            if (isShareFlag) {
              // jsonObj['competitorCode'] = record.competitorCode
              jsonObj['recordKey'] = record.recordKey
            }

            let recordItemForTheme = {
              isShareFlag,
              analysisItemName: themeItem.analysisItemName
                ? themeItem.analysisItemName
                : '',
              analysisItemId: themeItem.analysisItemId
                ? themeItem.analysisItemId
                : '',
              phaseId: themeItem.phaseId ? themeItem.phaseId : 0,
              matchId: 0, //纪录分享没有比赛
              analysisType: themeItem.analysisType
                ? themeItem.analysisType
                : '',
              groupType: themeItem.groupType ? themeItem.groupType : 0,
              json: jsonObj ? JSON.stringify(jsonObj) : '',
              seasonOrMatch: themeItem.seasonOrMatch
                ? themeItem.seasonOrMatch
                : null,
              dataItemName: themeItem.analysisItemName
                ? themeItem.analysisItemName
                : '',
              dataImg: themeItem.dataImg ? themeItem.dataImg : '',
              useScene: themeItem.useScene,
              analysisItemStyles: themeItem.analysisItemStyles,
            }
            return Object.assign(record, recordItemForTheme)
          })
        : []
      console.debug('tableData:', this.tableData)
    },
    scrollListenerEvent() {
      const scrollTop = this.scrollAreaDom.scrollTop
      const scrollHeight = this.scrollAreaDom.scrollHeight
      const parentHeightPx = this.scrollAreaDom.offsetHeight
      let direction = this.DIRECTION_ENUM.DOWN
      if (this.beforeScrollTop > scrollTop) {
        direction = this.DIRECTION_ENUM.UP
      }
      // 通过滚动方向判断是触底还是触顶
      // console.debug(
      //   'direction:',
      //   direction,
      //   scrollTop,
      //   parentHeightPx,
      //   scrollHeight,
      //   this.isScrollBottom
      // )
      // this.changeMatchLabelFixed(scrollTop, direction)
      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }

      if (direction == this.DIRECTION_ENUM.DOWN) {
        // 滚动触底
        if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
          console.debug('滚动触底')
          this.isScrollBottom = true
        }
      } else {
        // 滚动到顶部
        this.isScrollBottom = false
        if (scrollTop <= this.threshold) {
          console.debug('滚动到顶部')
        }
      }

      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }
      this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      // console.debug(
      //   'this.parentWidthPx:',
      //   this.$refs.tableParentDom.scrollHeight
      // )
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      window.addEventListener('resize', () => {
        this.onResizeEvent()
      })
      // this.scrollAreaDom = document.getElementsByClassName(
      //   `${this.scrollDomClassName}`
      // )[0]
      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        console.debug(
          'computedSelectOpt:',
          config,
          this[config.dataName],
          list,
          mix_id
        )
        selectOpt_list.push({
          type: config.type,
          title: config.title,
          keyVal: [mix_id, config.origin_keyVal[1]],
          curId: list[config.selectIndex]?.[mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
          curVal: list[config.selectIndex]?.[config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
          disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
          isFilterable: config.isFilterable ? config.isFilterable : false,
          list,
        })
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    async changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'recordType') {
            this.currStageRecordType = valPathArr[1]
            // await this.getBigSportsList()
            // this.computedSelectOpt(this.selectOptData.configArr)
          } else if (valPathArr[0] === 'bigSports') {
            this.currStageBigSports = valPathArr[1]
            await this.getRecordTypeList()
            this.computedSelectOpt(this.selectOptData.configArr)
          } else {
          }
          // 筛选表格逻辑
          this.getRecordList()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedTableData(data, isShareFlag) {
      if (data) {
        this.tableTotal = data ? data.length : 0
        // 表头
        const columns = [
          {
            colKey: 'date',
            colTitle: '日期',
          },
          {
            colKey: 'sportsNameEventName',
            colTitle: '项目',
          },
          {
            colKey: 'resultValue',
            colTitle: '成绩',
          },
          {
            colKey: isShareFlag ? 'publishBtn' : 'publishBtn_hide',
            colTitle: '',
          },
        ]
        const otherColumns = columns

        if (this.tableColumnData.length == 0) {
          let tableColumnData = []
          const customColumn1 = {
            prop: 'delegationLogo-delegationId-delegationName', //fristColumnPropArr.join('-'),
            label: '代表团',
            widthVw: 13.88, //对应列的宽度，单位vw
            className: 'columnTitleLeft', //单独定制的头部样式class
            // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          }

          const customColumn2 = {
            prop: 'playerNameList', //fristColumnPropArr.join('-'),
            label: '运动员',
            widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
            className: 'columnTitleLeft', //单独定制的头部样式class
            // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          }

          for (let i = 0; i < otherColumns.length; i++) {
            const item = otherColumns[i]
            tableColumnData.push({
              prop: item.colKey,
              label: item.colTitle,
              widthVw: ['publishBtn', 'publishBtn_hide'].includes(item.colKey)
                ? 5.55
                : this.tableCellDefaultWidthVw,
              className: '', //单独定制的头部样式class
            })
            if (i == 2) {
              tableColumnData.push(customColumn1)
              tableColumnData.push(customColumn2)
            }
          }
          this.defaultWidthVwNum = tableColumnData.length - 3

          this.tableColumnData = tableColumnData
        }

        this.tableData = data
          ? data.map((record, index) => {
              let recordItem = {
                isShareFlag: false, //初始化默认是false
                id: index + 1,
                recordKey: record.recordKey,
                date: record.recordDate,
                resultValue: record.resultValue,
                playerListString:
                  record.athletes && record.athletes.length > 0
                    ? record.athletes
                        .map((playerItem) => {
                          return playerItem.athleteName
                        })
                        .join(' / ')
                    : '',
                sportsNameEventNameWeb: `${record.disciplineName}·${record.recordName}`,
                delegationName: record.organisationName,
                delegationLogo: record.organisationLogo,
                delegationId: record.organisationCode,
                sportsId: record.disciplineId ? record.disciplineId : 0,
                eventId: record.eventId ? record.eventId : 0,

                // analysisItemName:
                //   themeItem && themeItem.analysisItemName
                //     ? themeItem.analysisItemName
                //     : '',
                // analysisItemId:
                //   themeItem && themeItem.analysisItemId
                //     ? themeItem.analysisItemId
                //     : '',
                // phaseId: themeItem && themeItem.phaseId ? themeItem.phaseId : 0,
                // matchId: 0, //纪录分享没有比赛
                // analysisType:
                //   themeItem && themeItem.analysisType
                //     ? themeItem.analysisType
                //     : '',
                // groupType:
                //   themeItem && themeItem.groupType ? themeItem.groupType : 0,
                // json: jsonObj ? JSON.stringify(jsonObj) : '',
                // seasonOrMatch:
                //   themeItem && themeItem.seasonOrMatch
                //     ? themeItem.seasonOrMatch
                //     : null,
                // dataItemName:
                //   themeItem && themeItem.analysisItemName
                //     ? themeItem.analysisItemName
                //     : '',
                // dataImg:
                //   themeItem && themeItem.dataImg ? themeItem.dataImg : '',
              }
              return recordItem
            })
          : []
        // this.$refs.tableParentDom.scrollTo(0, 0)
        // console.debug('this.tableData:', this.tableData)
      } else {
        console.debug('暂无数据')
      }
    },
    async getRecordList() {
      if (!this.currStageBigSports) {
        this.tableTotal = 0
        this.tableData = []
        return
      }
      await https_recordList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        recordType: this.currStageRecordType ? this.currStageRecordType : '',
        sportsId: this.currStageBigSports ? this.currStageBigSports : '',
        timeZone: this.curTimeZoneItem.val, // 'beijing',
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              this.tableTotal =
                res.data && res.data.length ? res.data.length : 0
              this.orgin_tableData = res.data
              // this.computedTableData(this.orgin_tableData)
              // 初始化时需要等主题返回之后在组装数据；初始化之后，每次切换数据时可以直接组装数据
              if (this.themeItem) {
                this.computedTableData(this.orgin_tableData, true)
                this.shareDataAddThemeItem(this.themeItem)
              } else {
                this.computedTableData(this.orgin_tableData, false)
              }
            } else {
              console.debug('暂无数据')
              this.tableTotal = 0
              this.tableData = []
            }
            console.debug(
              '暂无数据:',
              this.tableTotal,
              this.orgin_tableData,
              this.orgin_tableData.length
            )
            this.$nextTick(() => {
              this.loading = false
              this.initScroll()
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getRecordTypeList() {
      if (!this.currStageBigSports) return

      let selectIndex = 0
      this.bigSportsArr.forEach((item, itemIndex) => {
        if (item.value === this.currStageBigSports) {
          selectIndex = itemIndex
        }
      })

      let params = {
        sid: this.currSid,
        dCode: this.currStageBigSports,
      }
      await https_record_newRecordType(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            this.recordTypeArr = (res?.data || []).map((item) => ({
              value: item.code,
              name: item.name,
            }))
            this.currStageRecordType = this.recordTypeArr[0]?.value || ''
            if (res.data?.length) {
              this.selectOptData = {
                configArr: [
                  {
                    type: 'bigSports',
                    title: '项目',
                    origin_keyVal: ['value', 'name'],
                    dataName: 'bigSportsArr',
                    selectIndex,
                    isFilterable: true,
                  },
                  {
                    type: 'recordType',
                    title: '纪录类型',
                    origin_keyVal: ['value', 'name'],
                    dataName: 'recordTypeArr',
                    selectIndex: 0,
                  },
                ],
                selectOpt_list: [],
              }
            } else {
              console.debug('暂无数据')
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getBigSportsList() {
      await https_record_newSportsList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            this.selectOptData = {
              configArr: [
                {
                  type: 'bigSports',
                  title: '项目',
                  origin_keyVal: ['value', 'name'],
                  dataName: 'bigSportsArr',
                  selectIndex: 0,
                  isFilterable: true,
                },
              ],
              selectOpt_list: [],
            }
            this.bigSportsArr = (res?.data || []).map((item) => {
              return {
                value: item.disciplineCode,
                name: item.disciplineName,
              }
            })
            this.currStageBigSports = this.bigSportsArr[0]?.value || ''
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_record {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .teamTable {
    padding: 2.778vw 0 6.964vw;
    .tableScrollArea {
      position: relative;
      .match_label_fixed {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 3.472vw;
        background-color: var(--mixtmt_whiteColor);
        .match_label {
          width: 100%;
          height: 3.472vw;
          background-image: var(--mixtmt_scheduleMatchList_dateBg);
          background-size: 100% auto;
          background-position: left top;
          background-repeat: no-repeat;

          .label_textArea {
            position: absolute;
            left: 0;
            top: 0.347vw;
            z-index: 2;
            width: 21.55%;
            padding-top: 0.6%;
            font-size: 1.38vw;
            color: var(--mixtmt_whiteColor);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            .labelIcon {
              width: 1.8vw;
              height: 1.8vw;
              overflow: hidden;
              margin-right: 0.694vw;
              background-color: #ccc;
            }
            & .letterSpa {
              letter-spacing: 0.4vw;
            }
          }
          .label_rightArea {
            position: absolute;
            right: 0;
            top: 0.347vw;
            z-index: 2;
            width: auto;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            color: var(--mixtmt_greyColor3);
            .rightArea_name,
            .rightArea_value {
              font-size: 1.11vw;
            }
            .rightArea_value {
              width: 2.5vw;
              text-align: center;
            }
          }
        }
      }
      /* .scrollDomContain {
        max-height: calc(100vh - 19.142vw);
        overflow: auto;
        .players_list {
          width: 100%;
          height: auto;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
        }
      } */
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}
</style>
